/*
 * @FilePath: \kitchen-online-web\src\redux\initState.js
 * @Author: Yu Wang
 * @Date: 2021-07-26 17:22:11
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-17 16:25:55
 */
import { defaultSize } from '@/utils/rules/const';

const initialValue = {
  count: 1,
  jsonTemplate: {}, // TEMPLETE-JSON
  TemporaryJson: {}, // 暂存的TEMPLETE-JSON

  getStepDetail: {}, // 清单数据
  TemporaryDetail: {}, // 暂存的清单数据

  oldTempleteJson: {}, // 存放更改时候第一次的templete，
  oldTemplate: {},

  sizeUnder: { key: 'L' }, // 底柜尺寸形状
  TempSizeUnder: { key: '' }, // 暂存的底柜形状

  lenUnder: { id: '' }, // 底柜尺寸长度
  TempLenUnder: { id: '' }, // 暂存的底柜尺寸长度

  faucetComponentId: undefined, // 水龙头id
  highUnder: 2, // 底柜尺寸高度
  lengthVal: [defaultSize.L.bottom.len1, defaultSize.L.bottom.len2],
  stepList: [
    {
      title: '选择柜型',
      path: '/home/homepage/stepone',
    },
    {
      title: '尺寸输入',
      path: '/home/homepage/steptwo',
    },
    {
      title: '厨具位置摆放',
      path: '/home/homepage/stepthree',
    },
  ],
  // titleList:
  //   // 3105AB测试   删除的时候只需要保留一个  A方案删除:前面的内容
  //   localStorage.getItem('storageUser') === 'BUser'
  //     ? [
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/stepone',
  //       },
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/steptwo',
  //       },
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/stepthree',
  //       },
  //       {
  //         title: '2/5门板选择',
  //         path: '/home/doorPlank',
  //       },
  //       {
  //         title: '3/5台面选择',
  //         path: '/home/mesa',
  //       },

  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/recommendStorage',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/drawer',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/basket',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/sink',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/faucet',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/tallark',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/hand',
  //       },
  //       {
  //         title: '5/5厨房设计报价',
  //         path: '/home/offer',
  //       },
  //     ]
  //     : [
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/stepone',
  //       },
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/steptwo',
  //       },
  //       {
  //         title: '1/5柜型尺寸选择',
  //         path: '/home/homepage/stepthree',
  //       },
  //       {
  //         title: '2/5门板选择',
  //         path: '/home/doorPlank',
  //       },
  //       {
  //         title: '3/5台面选择',
  //         path: '/home/mesa',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/drawer',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/basket',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/sink',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/faucet',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/tallark',
  //       },
  //       {
  //         title: '4/5内配储物',
  //         path: '/home/storage/hand',
  //       },
  //       {
  //         title: '5/5厨房设计报价',
  //         path: '/home/offer',
  //       },
  //     ],
  titleList: [
    {
      title: '1/5柜型尺寸选择',
      path: '/home/homepage/stepone',
    },
    {
      title: '1/5柜型尺寸选择',
      path: '/home/homepage/steptwo',
    },
    {
      title: '1/5柜型尺寸选择',
      path: '/home/homepage/stepthree',
    },
    {
      title: '2/5门板选择',
      path: '/home/doorPlank',
    },
    {
      title: '3/5台面选择',
      path: '/home/mesa',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/drawer',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/basket',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/sink',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/faucet',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/tallark',
    },
    {
      title: '4/5内配储物',
      path: '/home/storage/hand',
    },
    {
      title: '5/5厨房设计报价',
      path: '/home/offer',
    },
  ],
  lengthTopVal: [defaultSize.L.top.len1, defaultSize.L.top.len2],
  sizeTop: {
    // 顶柜柜型id
    key: 'I',
  },
  lenTop: {
    // 底柜尺寸长度Id
    id: '',
  },
  refrigerId: 0,
  refrigerType: {}, // 冰箱类型
  TophighUnder: 2, // 顶柜尺寸高度
  // tabList:
  //   // 3105AB测试  删除的时候只需要保留一个   A方案删除:前面的内容
  //   localStorage.getItem('storageUser') === 'BUser'
  //     ? [
  //       // 内配tab
  //       {
  //         navName: '储物收纳',
  //         key: 'first',
  //         url: 'recommendStorage',
  //       },
  //       {
  //         navName: '水槽',
  //         key: 'second',
  //         url: 'sink',
  //       },
  //       {
  //         navName: '水龙头',
  //         key: 'third',
  //         url: 'faucet',
  //       },
  //       {
  //         navName: '把手',
  //         key: 'fourth',
  //         url: 'hand',
  //       },
  //     ]
  //     : [
  //       // 内配tab
  //       {
  //         navName: '抽屉',
  //         key: 'first',
  //         url: 'drawer',
  //       },
  //       {
  //         navName: '调料柜/转篮',
  //         key: 'second',
  //         url: 'basket',
  //       },
  //       {
  //         navName: '水槽',
  //         key: 'third',
  //         url: 'sink',
  //       },
  //       {
  //         navName: '水龙头',
  //         key: 'fourth',
  //         url: 'faucet',
  //       },
  //       {
  //         navName: '高柜',
  //         key: 'five',
  //         url: 'tallark',
  //       },
  //       {
  //         navName: '把手',
  //         key: 'six',
  //         url: 'hand',
  //       },
  //     ],
  tabList: [
    // 内配tab
    {
      navName: '抽屉',
      key: 'first',
      url: 'drawer',
    },
    {
      navName: '调料柜/转篮',
      key: 'second',
      url: 'basket',
    },
    {
      navName: '水槽',
      key: 'third',
      url: 'sink',
    },
    {
      navName: '水龙头',
      key: 'fourth',
      url: 'faucet',
    },
    {
      navName: '高柜',
      key: 'five',
      url: 'tallark',
    },
    {
      navName: '把手',
      key: 'six',
      url: 'hand',
    },
  ],
  checkedTabList: ['first'],
  currentTab: 'first',
  currentTitle: '1/5柜型尺寸选择', // 初始页面路由标题
  arrowShow: true, // 判断返回逻辑是否上一页，还是报价页面
  nextTab: false, // 判断是否跳转内配的tab组件，还是跳转页面
  bottomDoorList: {
    // 底柜门板信息
    flag: '',
    id: '',
    materialType: '',
    globalName: '',
    price: '1000',
    qualityImageUrl: '',
    productId: '',
    recommend: null,
    simpleIntroduction: null,
    validDesignText: '',
  },
  topDoorList: {
    // 顶柜门板信息
    flag: '',
    id: '',
    materialType: '',
    globalName: '',
    price: '1000',
    qualityImageUrl: '',
    productId: '',
    recommend: null,
    simpleIntroduction: null,
    validDesignText: '',
  },
  bottomDoorScreen: {
    // 底柜门板筛选信息
    materialList: [],
    colorList: [],
    priceList: [],
    disableMaterialList: [], // 设置 disable 材质
    disableColorList: [], // 设置 disable 颜色
    disablePriceList: [], // 设置 disable 价格
  },
  topDoorScreen: {
    // 顶柜门板筛选信息
    materialList: [],
    colorList: [],
    priceList: [],
    disableMaterialList: [], // 设置 disable 材质
    disableColorList: [], // 设置 disable 颜色
    disablePriceList: [], // 设置 disable 价格
  },
  mesaList: {
    // 台面信息
    brandId: '',
    globalName: '',
    height: '',
    id: '',
    imageUrl: '',
    measureText: '',
    totalPrice: '',
    typeCode: '',
    typeName: '',
    validDesignText: '',
    width: '',
  },
  mesaScreen: {
    // 台面筛选信息
    materialList: [],
    colorList: [],
    priceList: [],
    disableMaterialList: [], // 设置 disable 材质
    disableColorList: [], // 设置 disable 颜色
    disablePriceList: [], // 设置 disable 价格
  },
  storage: {
    // 内配信息
    drawer: {
      // 抽屉信息
      id: '',
      image: '',
      material: '',
      name: '',
      price: '',
    },
    basketTop: {
      globalName: '',
      imageUrl: '',
      measureText: null,
      name: '',
      price: '',
      recommend: null,
    },
    sink: {
      // 水槽信息
      globalName: '',
      id: '',
      imageUrl: '',
      measureText: '',
      price: null,
      typeName: '',
      validDesignText: '',
    },
    tallArk: [
      // { // 高柜信息
      //   globalName: '',
      //   id: '',
      //   imgUrl: '',
      //   name: '',
      //   price: '',
      // }
    ],
    hand: {}, // 把手信息
  },
  detailedList: {}, // 清单明细
  drawerNum: [0, 0, 0], // 抽屉数量
  topBaskNum: [], // 顶柜内配数量
  underBaskNum: [], // 底柜内配数量
  calloutline: { bottom: {}, top: {} }, // 3d标注
  engine3D: null, // 3D引擎
  doorDetail: {}, // 保存门板详情
  Modify: false, // 是否修改过TEMPLETEJSON，修改过就update
  isTempleteSave: false, // 去报价或者修改确定为true调取接口
  backFromSize: true, // 修改判断是确定还是返回
  showLoading: false,
  capitalRetention: false, // 是否留资
  designCode: '', // 厨房代码客服用
  houseState: null, // 房屋状态
  serviceMark: null, // 服务商场

  // version2.0   有无顶柜
  hasTopCabinet: true, // 是否需要顶柜
  location: {
    sinkLocation: null, // 水槽位置
    cookLocation: null, // 灶台位置
  },

  // 底柜门板列表
  bottomCabinetList: [],
  // 顶柜门板列表
  topCabinetList: [],

  isgoEdit: false, // 是否进入过修改页面，直接退出用
  isJump: false, // 用来设置scroll为0，时机是路由跳转并且子组件渲染完成后
  is3DFirstInit: false, // 第一次调用callEngine的init结束设为true，用来确定3D手势提示显示的时机
  sizeMark: true, // 尺寸页面的标线
  otherMark: false, // 其他页面的标线
  filterColor: false, // 其墙面地面颜色菜单栏开关
  doorCallEngineEnd: false, // 第一次进入门板页面3D渲染是否完成
  isFirstintoDoor: true, // 是否第一次进入门板页面
  existWindow: true, // 是否可以展示窗户
  isWindow: true, // 是否展示窗户
  istip: false, // 是否展示手势图示
  sizeSign: false, // 当尺寸修改弹窗关闭时为true
  isShowFilter: false, // 门板台面显示筛选条件
  LImageReversal: false, // L型底柜图片是否展示尺寸交换后的图
  showInitLoading: false, // 组件——3D模型生成中
  replacepathList: [], // 缺货替换的路径保存
  doorStock: false, // 门板是否缺货
  mesaStock: false, // 台面是否缺货
  sinkStock: false, // 台面是否缺货
  faucetStock: false, // 水龙头是否缺货
  handStock: false, // 台面是否缺货
  storageStock: false, // 内配是否缺货
  ispackOffer: false, // 是否例子页
  isHighlowCabinet: false, // 是否高低柜
  isChangeTopTips: false, // 更改顶柜位置tips
  isSeat: 'R', // 顶柜位置左中右
  featLeft: '50%', // 顶柜换边按钮到左侧的距离
  isChangeApi: false, // 修改时切换柜型，调用接口init/update
  selectCombo: 'basic', // 默认选中的为basic  basic | advance | elaborate
};

export default initialValue;
